import { useRef, useState, useEffect } from 'react';

export const useGoogleOAuthButtonPresenter = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [buttonWidth, setButtonWidth] = useState<number | undefined>(undefined);

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout> | null = null;

    const updateWidth = () => {
      if (containerRef.current) {
        setButtonWidth(containerRef.current.offsetWidth);
      }
    };

    const debouncedUpdateWidth = () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(updateWidth, 300);
    };

    // Initial width measurement (no delay)
    updateWidth();

    const resizeObserver = new ResizeObserver(debouncedUpdateWidth);
    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }

    return () => {
      resizeObserver.disconnect();
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, []);

  return {
    containerRef,
    buttonWidth,
  };
};
